export default __webpack_public_path__ + "static/media/element-panel-photo.1ad49e54.png";